"use client";

import { useEffect } from "react";

interface AbandonedIntentTrackerProps {
  locationQuery?: string;
  listingId?: string;
}

const AbandonedIntentTracker = ({
  locationQuery,
  listingId,
}: AbandonedIntentTrackerProps) => {
  useEffect(() => {
    if (!locationQuery?.trim()) return;

    let consent: "accepted" | "rejected" | "unset" = "unset";
    try {
      const stored = localStorage.getItem("cookieConsent") as
        | "accepted"
        | "rejected"
        | null;
      consent = stored || "unset";
    } catch {
      consent = "unset";
    }

    fetch("/api/abandoned-intent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        locationQuery,
        listingId,
        consent,
      }),
    }).catch(() => {
      // Silent fail to avoid affecting UX
    });
  }, [locationQuery, listingId]);

  return null;
};

export default AbandonedIntentTracker;

